var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 3.67045L14.8171 17.2071M8.81714 2.70354L8.81714 18.174M1.81714 10.4388H19.8171M1.81714 4.62689L1.81714 16.2507C1.81714 17.5696 1.81714 18.229 2.09848 18.6861C2.34516 19.0869 2.73334 19.388 3.19148 19.5339C3.71398 19.7003 4.37976 19.5572 5.71131 19.2711L17.3113 16.7787C18.2054 16.5865 18.6525 16.4905 18.9862 16.258C19.2806 16.053 19.5117 15.7744 19.6548 15.4521C19.8171 15.0867 19.8171 14.6439 19.8171 13.7582V7.11936C19.8171 6.23374 19.8171 5.79093 19.6548 5.42552C19.5117 5.10321 19.2806 4.82462 18.9862 4.61958C18.6525 4.38712 18.2054 4.29106 17.3113 4.09894L5.71132 1.60647C4.37976 1.32036 3.71398 1.1773 3.19148 1.3437C2.73334 1.4896 2.34517 1.79068 2.09848 2.19146C1.81714 2.64854 1.81714 3.30799 1.81714 4.62689Z",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuShelf);
export default __webpack_public_path__ + "static/media/menu_shelf.5f4a2b49aa6caa238fd45a03ac587d7f.svg";
export { ForwardRef as ReactComponent };